import axios from "../../../axios";

export const UserHistory = async (payload) => {
  return axios.post("/api/Admin/UserHistory", payload);
};

export const GetAllUsers = async (payload) => {
  return axios.get("/api/Admin/GetAllUsers", payload);
};